<template>
  <div>
    <router-view :key="$route.fullPath" />
  </div>
</template>



<script>


export default {
  name: 'App',
  data() {
    return {

    }
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 15px; */
</style>



// WEBPACK FOOTER //
// src/App.vue